/**
 * `/:world`: a world's home — what the world is, and its sub-series to choose
 * from. The design agreed for the front page, now one level down: the front
 * page of the site is the worlds.
 *
 * The lead is the world's own text from the database. Its counts are filled
 * from the catalogue at render time, so the prose cannot drift from the books.
 */

import { Link } from 'react-router'
import { worldPath } from '../../shared/routes.ts'
import { CataloguePage, SeriesCards, usePageTitle } from '../components/Catalogue.tsx'
import { Branch, Compass, Constellation } from '../components/Ornament.tsx'
import { useI18n } from '../i18n/index.tsx'
import { fill, pick, worldName, type Loaded } from '../lib/catalogue.ts'

export function WorldHome() {
  return <CataloguePage>{(catalogue, world) => <WorldHomeView catalogue={catalogue} world={world} />}</CataloguePage>
}

function WorldHomeView({ catalogue, world }: { catalogue: Loaded; world: string }) {
  const { t, locale } = useI18n()
  usePageTitle(worldName(catalogue.universe, locale))
  const intro = pick(catalogue.universe, 'intro', locale)

  return (
    <>
      <section className="band band--ink">
        <div className="band__inner hero">
          <Constellation />
          <div className="hero__text">
            <h1>{t('app.tagline')}</h1>
            {intro === null ? null : (
              <p>{fill(intro, { works: catalogue.works.length, series: catalogue.series.length })}</p>
            )}
            <nav className="panel__links">
              <Link to={worldPath(world, 'books')}>{fill(t('home.all_books'), { count: catalogue.works.length })}</Link>
            </nav>
          </div>
          <div className="hero__mark">
            <Compass size={140} on="ink" />
          </div>
        </div>
      </section>

      <section className="wide">
        <div className="section-heading">
          <Branch />
          <h2>{t('home.choose')}</h2>
        </div>
        <SeriesCards catalogue={catalogue} world={world} headingLevel={3} />
      </section>
    </>
  )
}
